import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmationDialogData {
  title?: string;
  content?: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'si-confirmation-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent implements OnInit {
  data: ConfirmationDialogData = inject(MAT_DIALOG_DATA);

  title: string;
  content: string;
  cancelText: string;
  confirmText: string;

  ngOnInit(): void {
    ({
      title: this.title = 'Confirm Action',
      content: this.content = 'Are you sure you want to proceed?',
      confirmText: this.confirmText = 'Confirm',
      cancelText: this.cancelText = 'Cancel'
    } = this.data || {});
  }
}
